import styled from '@emotion/styled'
import React from 'react'
import { CategoryKind, CategoryKindType } from '../../types/CategoryKind'
import CommonNavLink from '../atoms/commonNavLink'
import useRouteParam from '../../hooks/useRouteParam'
import BreakPoints from '../../styles/breakPoints'

const Wrapper = styled.nav`
  width: 100%;
  text-align: center;
  justify-content: space-between;
  display: flex;
  position: sticky;
  top: 0;
  padding: 10px 0;
  background: #f8f8f8;
  z-index: 1;

  .select {
    color: #ffffff;
    background: #19ba9b;
  }

  ${BreakPoints.large} {
    height: 55px;

    a {
      display: none;
    }
  }
`
type IProps = {
  /** ページタイプ */
  categoryKind?: CategoryKindType
}

/**
 * セクションボタンエリア
 * @constructor
 */
const SectionBtnArea = ({ categoryKind }: IProps) => {
  const routeParam = useRouteParam('/help/first/')
  const routeParam2 = useRouteParam('/help/guide/')
  const routeParam3 = useRouteParam('/help/manage/')
  const routeParam4 = useRouteParam('/help/setting/')
  const routeParam5 = useRouteParam('/help/movie/')
  const routeParam6 = useRouteParam('/help/faq/')

  return (
    <Wrapper>
      <CommonNavLink
        href={routeParam}
        className={categoryKind === CategoryKind.FIRST ? 'select' : undefined}
        label="はじめてガイド"
      />
      <CommonNavLink
        href={routeParam2}
        className={categoryKind === CategoryKind.GUIDE ? 'select' : undefined}
        label="ご利用ガイド"
      />
      <CommonNavLink
        href={routeParam3}
        className={categoryKind === CategoryKind.MANAGE ? 'select' : undefined}
        label="管理職機能"
      />
      <CommonNavLink
        href={routeParam4}
        className={categoryKind === CategoryKind.SETTING ? 'select' : undefined}
        label="各種設定"
      />
      <CommonNavLink
        href={routeParam5}
        className={categoryKind === CategoryKind.MOVIE ? 'select' : undefined}
        label="動画マニュアル"
      />
      <CommonNavLink
        href={routeParam6}
        className={categoryKind === CategoryKind.FAQ ? 'select' : undefined}
        label="よくあるご質問"
      />
    </Wrapper>
  )
}
export default SectionBtnArea
